import { window } from '../../../../globals';
import queryClient from '../../../../ReactQuery/client';
import useToastedMutation from '../../../../ReactQuery/useToastedMutation';
import { remove } from '../../../../redux/api';
import type { DeleteGitLabInstanceRequest } from '../../../../../shared/settings/gitlab';

import { getGitLabSettingsQueryKey } from './useGetGitLabSettings';

function deleteGitLabInstance(orgId: number, instanceId: number) {
  const body: DeleteGitLabInstanceRequest = { id: instanceId };
  return remove<DeleteGitLabInstanceRequest, null>(`/api/organizations/${orgId}/settings/integrations/gitlab`, { body, json: true });
}

/**
 * Deletes a GitLab instance from the organization.
 */
export default function useDeleteGitLabInstance(instanceId: number) {
  return useToastedMutation({
    mutationFn: () => deleteGitLabInstance(window.user?.organizationId ?? 0, instanceId),
    onSuccess: () => {
      queryClient.invalidateQueries(getGitLabSettingsQueryKey(window.user?.organizationId ?? 0));
    },
    successToastMessage: 'GitLab instance deleted successfully.',
    errorToastMessage: 'Failed to delete GitLab instance.',
  });
}
